import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
} from '../../shared/constants/ActionTypes';
import appAxios, {
  getAccessToken,
  setAuthToken,
  getVendorId,
  getReCaptchaToken,
} from './base-api';
import {isShowRecaptcha} from '../utility/Utils';
import {useAuthMethod} from '../utility/AuthHooks';
import {setIsloading} from 'redux/actions';
import { encryptStorage } from '@ict/utility/Storage';

export default {
  setupInterceptor: () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const {setJWTData} = useAuthMethod();

    appAxios.interceptors.request.use(
      (conf) => {
        dispatch(setIsloading(true));
        dispatch({type: FETCH_START});
        const accessToken = getAccessToken();
        const vendorId = getVendorId();
        const reCaptchaToken = getReCaptchaToken();

        if (conf.url.includes('public/publickey')) {
          conf.headers.Authorization = null;
        } else if (accessToken && !conf.url.includes('login')) {
          conf.headers.Authorization = `Bearer ${accessToken}`;
        } else if (conf.url.includes('login')) {
          conf.headers.Authorization = accessToken;
          conf.headers.vendorId = vendorId;
          conf.headers.response = reCaptchaToken;
        }
        return conf;
      },
      (error) => {
        setTimeout(() => {
          dispatch(setIsloading(false));
        }, 2000);
        return Promise.reject(error);
      },
    );
    appAxios.interceptors.response.use(
      (res) => {
        if (res.config.url.includes('auth') || res.config.url.includes('login'))
          setAuthToken(res.headers.access_token);
        dispatch({type: FETCH_SUCCESS});
        setTimeout(() => {
          dispatch(setIsloading(false));
        }, 2000);
        return Promise.resolve(res);
      },
      (err) => {
        return new Promise(() => {
          setTimeout(() => {
            dispatch(setIsloading(false));
          }, 2000);
          if (err?.response) {
            switch (err?.response?.status) {
              case 401: {
                dispatch({
                  type: FETCH_ERROR,
                  payload: err.response.data.message,
                });
                if (!err.config.url.includes('login')) {
                  setJWTData(false);
                  isShowRecaptcha(true);
                  history.replace('/laju/ui');
                }

                if (
                  err.response.data.message === 'authentication.exception.001'
                ) {
                  setJWTData(false);
                } else if (
                  err.response.data.message === 'jwtverification.exception.001'
                ) {
                  setJWTData(false);
                  encryptStorage.removeItem('userBranch');
                  encryptStorage.removeItem('publicKey');
                  encryptStorage.removeItem('vendorId');
                  encryptStorage.removeItem('userRole');
                  encryptStorage.removeItem('tokenReCaptcha');
                  encryptStorage.removeItem('token');
                }
                break;
              }
              case 403: {
                setJWTData(false);
                dispatch({
                  type: FETCH_ERROR,
                  payload: err.response.data.message,
                });
                if (
                  err.response.data.message === 'authentication.exception.002'
                ) {
                  setJWTData(false);
                } else if (
                  err.response.data.message === 'userlogin.exception.001'
                ) {
                  setJWTData(false);
                } else if (
                  err.response.data.message === 'recaptchainvalid.exception.001'
                ) {
                  setJWTData(false);
                } else if (
                  err.response.data.message === 'recaptchainvalid.exception.002'
                ) {
                  setJWTData(false);
                } else if (
                  err.response.data.message === 'userlogin.exception.002'
                ) {
                  setJWTData(false);
                }  else {
                  setJWTData(false);
                }
                break;
              }
              case 404: {
                dispatch({
                  type: FETCH_ERROR,
                  payload: 'API Not Found ' + err.config.url,
                });
                break;
              }
              case 500: {
                history.replace('/500');
                break;
              }
              case 400: {
                if (err.response.data.business) {
                  dispatch({
                    type: FETCH_ERROR,
                    payload: err.response.data.message,
                  });
                  //setJWTData(true);
                  break;
                } else {
                  dispatch({
                    type: FETCH_ERROR,
                    payload: 'System Error, Please Contact your IT Department',
                  });
                  //setJWTData(true);
                  break;
                }
              }
              default: {
                dispatch({
                  type: FETCH_ERROR,
                  payload: 'System Error, Please Contact your IT Department',
                });
                setJWTData(true);
                break;
              }
            }
            return Promise.reject(err);
          } else {
            dispatch({
              type: FETCH_ERROR,
              payload: 'System Error, Please Contact your IT Department',
            });
            setJWTData(false);
            return Promise.reject(err);
          }
        });
      },
    );
  },
};
